import { ActionTree } from 'vuex';
import { Course, CourseState, Modality } from './state';
import { readSelectedModality, saveSelectedModality } from '@/helpers/selectedModalityStorage';
import RootState from '@/store/root_state';
import { MicroserviceEnum, query } from '@/helpers/westeros';
import { allCourses, AllCoursesQueryResult } from '@/store/graphql/queries/westerosQueries';
import i18n from '@/i18n';
import { UpsertAdmissionMutationInput } from '@/store/graphql/mutations/westerosMutations';

const actions: ActionTree<CourseState, RootState> = {
  async UPDATE_COURSE({ dispatch }, payload: { course: Course }): Promise<void> {
    const { course } = payload;

    const params: UpsertAdmissionMutationInput = { courseId: course.id };

    await dispatch('UPSERT_ADMISSION', params);
  },

  // Modalidade é só filtro de exibição (curso e polos) e não é gravada na admissão.
  async UPDATE_MODALITY({ commit, rootGetters }, payload: { modality: Modality }): Promise<void> {
    const { modality } = payload;

    saveSelectedModality(modality, rootGetters.admissionId);

    commit('SET_MODALITY', modality);
    commit('SET_AVAILABLE_CAMPUSES', []);
  },

  async RESTORE_SELECTED_MODALITY({ commit, rootGetters }): Promise<void> {
    const modality = readSelectedModality(rootGetters.admissionId);

    if (modality) commit('SET_MODALITY', modality);
  },

  async PULL_AVAILABLE_COURSES({ commit }): Promise<void> {
    const { data } = await query<AllCoursesQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      allCourses,
      { isAvailable: true },
      true,
    );

    const courses: Course[] = data.allCourses.map(
      ({ id, name, courseType, durationYears, modality }) => ({
        id,
        name,
        type: courseType,
        modality,
        duration: `${durationYears.toLocaleString()} ${i18n.tc('yearOfDuration', durationYears)}`,
      }),
    );

    commit(
      'SET_AVAILABLE_COURSES',
      courses.sort(({ name: name1 = '' }, { name: name2 = '' }) => name1.localeCompare(name2)),
    );
  },
};

export default actions;
